var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 67"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 11,
    cy: 10.5,
    r: 9,
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 11",
    d: "M20 10.5C20 5.52944 15.9706 1.5 11 1.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerIcon);
export default __webpack_public_path__ + "static/media/spinner_icon.8c14273f065d2203bd74d34940769bbf.svg";
export { ForwardRef as ReactComponent };